import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import {
  GET_MARGINS,
  getMarginsFailure,
  getMarginsSuccess,
  CREATE_MARGINS,
  createMarginsSuccess,
  createMarginsFailure,
  getMargins,
  CREATE_MARGIN_OVERRIDE,
  createMarginOverrideSuccess,
  createMarginOverrideFailure,
  DELETE_MARGIN_OVERRIDE,
  deleteMarginOverrideSuccess,
  deleteMarginOverrideFailure
} from '../actions/margins'
import {
  getMarginsService,
  createMarginsService,
  createMarginOverrideService,
  deleteMarginOverrideService
} from '../services/margins'
import { selectedPartnershipIdSelector } from '../selectors/partnerships'

function* marginsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_MARGINS, getMarginsWorker),
    takeEvery(CREATE_MARGINS, createMarginsWorker),
    takeEvery(CREATE_MARGIN_OVERRIDE, createMarginOverrideWorker),
    takeEvery(DELETE_MARGIN_OVERRIDE, deleteMarginOverrideWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getMarginsWorker({ params }) {
  try {
    const response = yield call(getMarginsService, params)
    yield put(getMarginsSuccess(response))
  } catch (e) {
    yield put(getMarginsFailure(e))
  }
}

function* createMarginsWorker({ marginsData }) {
  try {
    const response = yield call(createMarginsService, marginsData)
    yield put(createMarginsSuccess(response))

    // as BE manipulates previous created margins, these needs to be fetched again after new creation
    const selectedPartnershipId = yield select(selectedPartnershipIdSelector)
    yield put(getMargins({ partnership: selectedPartnershipId }))
  } catch (e) {
    yield put(createMarginsFailure(e))
  }
}

function* createMarginOverrideWorker({ marginOverrideData }) {
  try {
    const response = yield call(createMarginOverrideService, marginOverrideData)
    yield put(createMarginOverrideSuccess(response))

    // as BE manipulates previous created margins, these needs to be fetched again after new creation
    const selectedPartnershipId = yield select(selectedPartnershipIdSelector)
    yield put(getMargins({ partnership: selectedPartnershipId }))
  } catch (e) {
    yield put(createMarginOverrideFailure(e))
  }
}

function* deleteMarginOverrideWorker({ id }) {
  try {
    yield call(deleteMarginOverrideService, id)
    yield put(deleteMarginOverrideSuccess(id))
  } catch (e) {
    yield put(deleteMarginOverrideFailure(e))
  }
}

export default marginsWatcher
